import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";

import CreatableSelect from "react-select/creatable";
import FormStepsModal from "./FormStepsModal";
import Cookies from "js-cookie";

import { fetchAutoCompleteProductOrHashtagList } from "../../Product/productActions";
import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import { uploadLogo, plusIcon } from "../../../Shared/SVGs/Shared";
import { fieldStyles } from "./fieldStyle";

const Step1 = ({}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false); //TODO:

  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const form = useSelector((state) => state.campaign_states.form);
  const currentBrand = useSelector(
    (state) => state.navbarStatsReducer.currentBrand.name
  );
  const navbarStatsReducer = useSelector((state) => state.navbarStatsReducer);

  const productsList = useSelector(
    (state) => state.autoCompleteProductOrHashtagList.data
  );

  const dispatch = useDispatch();
  const sortedProductsList = productsList?.sort((a, b) =>
    a?.name?.localeCompare(b?.name)
  );
  const AddNewProduct = () => (
    <div onClick={() => setMenuIsOpen(false)} className="add-new-product">
      Add a new Product {plusIcon}
    </div>
  );
  const options = [
    { label: <AddNewProduct />, value: "add_new" },
    ...(sortedProductsList
      ? sortedProductsList?.map((k) => ({
          label: k.name?.toLowerCase(),
          value: k.id,
        }))
      : []),
  ];

  useEffect(() => {
    dispatch(
      fetchAutoCompleteProductOrHashtagList({
        is_hashtag: false,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
    );
  }, []);

  useEffect(() => {
    if (currentBrand) {
      dispatch(updateCampaignFields({ campaign_brand_name: currentBrand }));
    }
  }, [currentBrand]);

  const getPicture = (brandImage) => {
    const { profile_photo: profilePhoto } = brandImage || {};
    const { url } = profilePhoto || {};
    return url;
  };

  useEffect(() => {
    if (navbarStatsReducer) {
      dispatch(
        updateCampaignFields({
          campaign_brand_image_preview:
            getPicture(navbarStatsReducer?.brandPicture) ||
            require("@src/assets/images/vyrill/default.png").default,
          campaign_brand_image: getPicture(navbarStatsReducer?.brandPicture),
        })
      );
    }
  }, [navbarStatsReducer]);

  const handleLogoChange = (event) => {
    const selectedImage = event.target.files?.[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      dispatch(updateCampaignFields({ campaign_brand_image: reader.result }));
    };
    if (selectedImage) {
      reader.readAsDataURL(selectedImage);
      dispatch(
        updateCampaignFields({
          campaign_brand_image_preview: URL.createObjectURL(selectedImage),
        })
      );
    }
  };

  const uploadlogo = (
    <>
      <div style={{ marginTop: "10px" }}>
        {form.campaign_brand_image_preview ? (
          <img
            src={form.campaign_brand_image_preview }
            alt="Uploaded Logo"
            className="upload-img"
          />
        ) : (
          uploadLogo
        )}
      </div>
      {form.campaign_brand_image_preview ? null : (
        <label htmlFor="logo-upload-input" className="upload-text">
          Upload logo
        </label>
      )}
    </>
  );
  const filePicker = (
    <input
      type="file"
      accept="image/*"
      onChange={handleLogoChange}
      style={{ display: "none" }}
      id="logo-upload-input"
    />
  );
  const isNextButtonDisabled =
    !form?.campaign_headline || !form.campaign_brand_name;

  const handleChangeProduct = (data) => {
    if (Array.isArray(data)) {
      const containsAddNew = data.some((option) => option.value === "add_new");
      if (containsAddNew) {
        setMenuIsOpen(false);
      } else {
        dispatch(updateCampaignFields({ products: data || [] }));
      }
    }
  };
  const handleCheckboxChange = (value) => {
    dispatch(updateCampaignFields({ campaign_allow_rating: value }));
  };
  return (
    <>
      <div className="form-step-1">
        <FormGroup>
          <Label className="form-field-label">
            Campaign Headline<span style={{ color: "#E62580" }}>*</span>
          </Label>
          <FormStepsModal
            step={1}
            content={
              "Enter the campaign details in the provided fields as demonstrated on this page."
            }
            style={{ top: "143px", left: "30px" }}
          />
          <Input
            className="form-field"
            placeholder="Enter a catchy headline that will grab attention"
            type="text"
            style={{ height: "50px", width: "100%" }}
            value={form.campaign_headline}
            id="campaign_headline"
            onChange={(e) =>
              dispatch(
                updateCampaignFields({ campaign_headline: e.target.value })
              )
            }
          />
        </FormGroup>
        <FormGroup>
          <Label className="form-field-label">Campaign Hashtag</Label>
          <Input
            className="form-field"
            placeholder="Enter the campaign hashtag"
            type="text"
            style={{ height: "50px", width: "100%" }}
            value={form.campaign_hashtag}
            id="campaign_hashtag"
            onChange={(e) =>
              dispatch(
                updateCampaignFields({ campaign_hashtag: e.target.value })
              )
            }
          />
        </FormGroup>
        <Row className="form-control-row">
          <Col sm={9}>
            <FormGroup>
              <Label className="form-field-label">
                Brand Name & Logo<span style={{ color: "#E62580" }}>*</span>
              </Label>
              <Input
                className="form-field"
                placeholder="Enter your brand name here"
                type="text"
                style={{ height: "50px" }}
                value={form.campaign_brand_name}
                id="campaign_brand_name"
                onChange={(e) =>
                  dispatch(
                    updateCampaignFields({
                      campaign_brand_name: e.target.value,
                    })
                  )
                }
              />
            </FormGroup>
          </Col>
          {filePicker}
          <Col
            sm={3}
            className="upload-logo"
            role="button"
            onClick={() =>
              document.getElementById("logo-upload-input")?.click()
            }
          >
            {uploadlogo}
          </Col>
        </Row>

        <FormGroup>
          <Label className="form-field-label">
            Product Name<span style={{ color: "#E62580" }}></span>
          </Label>
          <div style={{ width: "600px" }}>
            <CreatableSelect
              isClearable
              isMulti
              onChange={handleChangeProduct}
              options={options}
              placeholder="Add the name of the product, service or brand featured in the campaign"
              value={form.products}
              styles={fieldStyles}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
              onMenuOpen={() => setMenuIsOpen(true)}
              onMenuClose={() => setMenuIsOpen(false)}
            />
          </div>
        </FormGroup>

        <Row className="form-control-row mt-4">
          <div className="d-flex align-items-center">
            <div className="form-field-label" style={{ marginRight: "71px" }}>
              Rate this Product / Brand
            </div>
            <div
              style={{ color: "black" }}
              className="d-flex align-items-center"
            >
              <input
                style={{ width: "18px", height: "18px" }}
                className="me-1"
                type="checkbox"
                checked={form.campaign_allow_rating === true}
                onChange={() =>
                  handleCheckboxChange(
                    form.campaign_allow_rating === true ? false : true
                  )
                }
              />
              <span className="me-3">Yes</span>
              <input
                className="me-1"
                style={{ width: "18px", height: "18px" }}
                type="checkbox"
                checked={form.campaign_allow_rating === false}
                onChange={() =>
                  handleCheckboxChange(
                    form.campaign_allow_rating === false ? true : false
                  )
                }
              />
              <span>No</span>
            </div>
          </div>
        </Row>
        <div className="center mt-5 mb-5">
          <Button
            className="campaign-button"
            size="lg"
            color={`${isNextButtonDisabled} ? secondary : primary`}
            onClick={() =>
              dispatch(updateCampaignState({ activeStep: activeStep + 1 }))
            }
            disabled={isNextButtonDisabled}
            style={{ background: isNextButtonDisabled ? "#C4C4C4" : "" }}
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
};

export default Step1;
